<div class="scs-wrapper">
 
  <!-- Header bar -->
  <div class="scs-header">
    <div class="scs-search-wrap">
      <span class="scs-search-icon">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="6" cy="6" r="4.5" stroke="currentColor" stroke-width="1.2"/>
          <path d="M9.5 9.5L12.5 12.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
        </svg>
      </span>
      <input
        class="scs-search"
        type="text"
        placeholder="Filter states…"
        [(ngModel)]="searchQuery"
        [ngModelOptions]="{standalone: true}"
        aria-label="Filter states"
      />
      @if(searchQuery){
      <button
        class="scs-search-clear"
        (click)="searchQuery = ''"
        aria-label="Clear search"
      >×</button>
      }
    </div>
 
    <div class="scs-summary">
      <span class="scs-summary-text">
        {{ totalSelectedCounties }} {{ totalSelectedCounties === 1 ? 'county' : 'counties' }}
        across {{ totalSelectedStates }} {{ totalSelectedStates === 1 ? 'state' : 'states' }}
      </span>
      @if(totalSelectedCounties > 0){<button class="scs-clear-btn" (click)="clearAll()">Clear all</button>}
    </div>
  </div>
 
  <!-- Empty state -->
  @if(filteredStateViewModels.length === 0){
      <div class="scs-empty">
      No states match "{{ searchQuery }}"
    </div>
  }
 
  <!-- Accordion list -->
  <div class="scs-list" role="tree" aria-label="State and county selector">
    @for(vm of filteredStateViewModels; track vm.state.id){
      <div class="scs-state-row" [class.scs-state-row--open]="vm.isOpen" [class.scs-state-row--selected]="vm.selectedCountyIds.size > 0">
        <!-- State header -->
        <div class="scs-state-header" role="treeitem" [attr.aria-expanded]="vm.isOpen" (click)="toggleState(vm)">
          <!-- State checkbox (select all / none) -->
          <button class="scs-checkbox" [class.scs-checkbox--all]="getStateCheckState(vm) === 'all'" [class.scs-checkbox--partial]="getStateCheckState(vm) === 'partial'" (click)="toggleAllCounties(vm, $event)"
            [attr.aria-label]="'Toggle all counties in ' + vm.state.name" type="button">
            @if(getStateCheckState(vm) === 'all'){
              <svg width="10" height="10" viewBox="0 0 10 10">
                <polyline points="1.5,5 4,7.5 8.5,2.5" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            }
            @else if(getStateCheckState(vm) === 'partial'){
              <svg width="10" height="10" viewBox="0 0 10 10">
                <line x1="2" y1="5" x2="8" y2="5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            }
          </button>
  
          <!-- State name + code -->
          <span class="scs-state-name">{{ vm.state.name }}</span>
          <span class="scs-state-code">{{ vm.state.stateCode }}</span>
  
          <!-- County count badge -->
          @if(vm.selectedCountyIds.size > 0){
            <span class="scs-county-badge">
              {{ vm.selectedCountyIds.size }}/{{ vm.counties.length }}
            </span>
          }
          @else{
            <span class="scs-county-badge scs-county-badge--muted">
              {{ vm.counties.length }}
            </span>
          }
  
          <!-- Expand arrow -->
          <span class="scs-arrow" [class.scs-arrow--open]="vm.isOpen">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        </div>
  
        <!-- County list -->
        @if(vm.isOpen){
        <div class="scs-county-list" role="group" [attr.aria-label]="vm.state.name + ' counties'">
          @for(county of vm.counties; track county.id){
            <div class="scs-county-item" [class.scs-county-item--selected]="isCountySelected(vm, county.id)" (click)="toggleCounty(vm, county.id)"
              role="treeitem" [attr.aria-selected]="isCountySelected(vm, county.id)" [attr.aria-label]="county.name + ' county'">
              <span class="scs-checkbox scs-checkbox--sm" [class.scs-checkbox--all]="isCountySelected(vm, county.id)">
                @if(isCountySelected(vm, county.id)){
                  <svg width="9" height="9" viewBox="0 0 10 10">
                    <polyline points="1.5,5 4,7.5 8.5,2.5" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                }
              </span>
              <span class="scs-county-name">{{ county.name }}</span>
            </div>
          }
        </div>
        }
      </div>
    }
  </div>
 
</div>